export enum MessagePanelSubDescriptionIcon {
  DEFAULT = 'default',
  FACE_AUTH = 'faceAuth',
  DOT = 'dot',
}

export enum MessagePanelSubDescriptionAlignment {
  DEFAULT = 'default',
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export interface MessagePanelSubDescription {
  title: string;
  icon?: MessagePanelSubDescriptionIcon;
  showAppIcons?: boolean;
  alignment?: MessagePanelSubDescriptionAlignment;
}

export default interface MessagePanelProps {
  title: string | string[];
  description: string | string[];
  subDescriptions?: MessagePanelSubDescription[];
  bottomDescription?: string;
  buttonLabel?: string;
  showLoading?: boolean;
  showSupportLink: boolean;
  translationVariables: Record<string, string>;
  // ID added to the message panel to check in tests
  // if the component was rendered
  dataTestId?: string;
  loading?: boolean;
  showUserInfo?: boolean;
  onConfirm?: () => void;
  showBack?: boolean;
  onBack?: () => void;
  supportLink?: string;
}
